import React from "react";
import PropTypes from "prop-types";

/** Label with required field display, htmlFor, and block styling */
function Label({ htmlFor, label, required, style: userStyles = {} }) {
    return (
        <label className="d-block" htmlFor={htmlFor} style={userStyles} >
            <b>{label}</b>
            {required && <span style={{ color: 'red' }}> *</span>}
        </label>
    )
}

Label.propTypes = {
    /**HTML ID for associate input */
    htmlFor: PropTypes.string.isRequired,

    /** Label text */
    label: PropTypes.string.isRequired,

    /** User defined styles */
    style: PropTypes.object,

    /** Display asterick after label if true */
    required: PropTypes.bool
}

export default Label;